let zh = {
  login: {
    login: "登录",
  },
  index: {
    hello: "你好，世界！",
    hi: "你好的另一个版本",
    signin: "行为打卡",
    Home: "首页",
    Mine: "我",
    search: "搜索课程/培训计划/学习项目",
    appstoryInfo: "支持离线下载，画面更高清流畅哦。",
    downloadApp: "下载APP",
    openApp: "打开 APP",
    useWeb: "使用网页学习",
  },
  // 365课程
  yearCourse: {
    learningToday: "今日学习",
    historyCourses: "往期回顾",
    credit: "分",
    studyCredit: "学分",
    lengthOfStudy: "已学时长",
    dailyReflection: "每日一省",
    hotPosts: "热门帖子",
    latestPosts: "最新帖子",
    forum: "学习社区",
    more: "更多",
    lookMore: "查看全部",
    lookMore2: "查看更多",
    learningTopics: "学习主题",
    details: "详情",
    introduction: "简 介",
    pushedToday: "今日推送",
    pushedOnTheDay: "当日推送",
    yourThoughts: "结合课程内容，谈谈你的想法吧~",
    save: "保存",
    submit: "发布",
    share: "分享",
    postToCommunity: "发布到社区",
    submitSuccess: "发布成功",
    edit: "修改",
    yourComment: "请输入你的评论（至少10个字）",
    commentList: "讨论列表",
    othersComment: "显示其他同学的内容",
    back: "返回",
    previousPage: "上一页",
    nextPage: "下一页",
    close: "收起",
    open: "展开",
    mySubmission: "我的每日一省",
    nullDailyReflection: "您还未发布每日一省",
    nullDailyReflection2: "结合课程内容，谈谈你的想法吧~",
    delete: "删除",
    post: "发帖",
    commentHint: "请输入内容...",
    postReply: "帖子回复",
    replys: "回复详情",
    reply: "回复",
    document: "文档",
    read: "阅读",
    article: "文章",
    warningHint: "内容不能少于10个字，请认真填写",
    PostContent: "回复内容不能为空",
    dailyReflectionDetails: "每日一省详情",
    nullContents: "暂无每日一省",
    deleteComment: "确定删除评论？",
    deleteReply: "确定删除回复？",
    searchContent: "搜索",
    public: "公开",
    onlyMe: "仅自己可见",
    photo: "图片",
    video: "视频",
    pushCourse: "定时推送",
    history: "学习足迹",
    missedCourses: "未学课程",
    community: "学习社区",
    writeContent: "写分享",
    showOther: "显示其他同学的内容",
    studyThem: "学习主题",
    contentDetails: "内容明细",
    contentType: "内容类型",
    completionTime: "完成时间",
    completedCourse: "学习了",
    sharedDaily: "发布了",
    ofPushCourse: "推送的课程",
    unpushHint: "课程很快就会推送给您哦~",
    uploadHint1: "最多只能上传3张图片或一个视频！",
    uploadHint2: "仅支持jpg和png格式图片！",
    uploadHint3: "选择单张图片不能超过5M！",
    uploadHint4: "上传视频不能超过100M！",
    uploadHint5: "只能上传图片或视频文件！",
    pinToTop: "置顶",
    postingInProgress: "发布中，请稍后刷新一下",
    deleteAsk: "发布中，确定删除吗？",
    cancel: "取消",
    unfinishedCourses: "暂无未学课程",
    fileConversion: "正在转码中，稍后请刷新页面",
    otherReflection: "TA的每日一省",
    studyTime: "学习时长(分钟)",
    studyIntegral2: "积分",
    footmark: "足迹",
  },
  // p2p学习
  P2PStudy: {
    learningPath: "学习路径",
    student: "学员",
    acivity: "我的活动",
    start: "起始",
    question: "开放式问题",
    suggestTime: "建议完成时间：",
    optional: "选学",
    valid: "有效期",
    until: "至",
  },
  // 登录
  loginPage: {
    login: "登 录",
    forget: "忘记密码?",
    namePlaceholder: "用户名",
    passPlaceholder: "密码",
    nullName: "用户名不能为空",
    nullPassword: "密码不能为空",
    experience: "注册体验",
    version: "当前版本:",
    captchaTitle: "输入图中验证码",
    captchaImgRefresh: "看不清？点击刷新",
    captchaError: "验证码错误",
    captchaSure: "确定",
  },
  // 忘记密码
  forgetPassPage: {
    title: "忘记密码",
    domainPlaceholder: "学习平台域名或企业ID号",
    namePlaceholder: "用户名",
    nextStep: "下一步",
    domainError: `该登录名没有设置手机号码或者登录名不存在 </br>请联系管理员重置密码`,
    nullDomain: "请完善平台信息",
    codePlaceholder: "请输入验证码",
    getVerificationCode: "获取验证码",
    newPaswPlaceholder: "请输入新密码",
    confirmPaswPlaceholder: "请再次输入新密码",
    resetPasswordBtn: "重置密码",
    paswInconsistent: "两次输入密码不一致",
    paswRange: "密码为8~32位字符",
    resetIsNull: "密码不能为空",
    send: "验证码已发送至手机",
    sendEmail: "验证码已发送至邮箱",
    clickFind: "点击找回",
    findMethod: "找回方式",
    mobileFind: "通过绑定手机号找回",
    emailFind: "通过绑定邮箱找回",
    friendTip: "友情提示",
    info1: "当账号",
    info2: "未绑定",
    info3:
      "手机号和邮箱时，将无法使用找回密码功能，如遇到该问题，请联系管理员手动重置密码。",
    text2: "已绑定",
    text3: "手机号或者邮箱时，可使用手机号/邮箱直接登录。",
    emailPsd: "可用邮箱找回密码",
    finished: "完成",
  },
  // 到期啦
  expiringPage: {
    pageTitle: "到期啦",
    timeUnit: "天",
    noData: "暂无相关数据~",
  },
  // 直播
  livingPage: {
    pageTitle: "直播",
    coverOverHint: "直播已结束",
    notStart: "未开始...",
    onLive: "直播中...",
    duringPlayback: "回放中...",
    isOver: "已结束...",
    lecturer: "讲师",
    broadcastTime: "已播时长",
    broadcastTime1: "已观看时长",
    theAirtime: "开播时间",
    playbackTime: "回放时间",
    endTime: "结束时间",
    courseDescription: "讲师介绍",
    introduction: "课程介绍",
    untime: "未到回放时间",
    uncomplete: "回放视频未生成",
  },
  // 账号设置
  accountSet: {
    title: "账号设置",
    setPhoto: "修改头像",
    modifyPasw: "修改密码",
    modifyEmail: "修改邮箱",
    modifyPhone: "修改手机号",
    oldPaswPlaceholder: "请输入原始密码",
    nullOldPasw: "请输入原密码",
    emailPlaceholder: "请输入邮箱地址",
    nullEmail: "邮箱不能为空",
    emailError: "邮箱格式不正确",
    phonePlaceholder: "请输入手机号",
    phoneNumberError: "请输入正确的手机号码",
    notBound: "未绑定",
    saveBtn: "保存",
    modifySuccess: "修改成功",
    modifyError: "修改失败",
    choose: "选择图片",
  },
  // 知识汇
  knowledgePage: {
    title: "知识汇",
    menuAll: "全部",
    allCategories: "全部分类",
    newest: "最新发布",
    host: "人气最高",
    favorites: "收藏最多",
    notPreview: "不支持预览",
    published: "发表于：",
    noData: "暂无数据",
    moreComment: "更多评论",
    writeComment: "写评论",
    detailTitle1: "文章详情",
    detailTitle3: "视频详情",
    detailTitle2: "文档详情",
    placeholder: "请输入您的评论...(512字以内)",
    textArea: "请输入512字以内的评价",
    sendBtn: "评论",
    submitBtn: "发表评论",
    commentState: "评论成功",
    commentError: "评论不能超过512字！",
    commentTitle1: "学员评论",
    commentTitle2: "评论详情",
    commentTitle3: "写评论",
    replies: "条回复",
    loadFinish: "我是有底线的~",
  },
  // 学习轨迹
  studyHistory: {
    title: "学习轨迹",
    cycleHint: "最近30天学习记录",
    studyType1: "在线课程",
    studyType2: "独立考试",
    studyType3: "作业",
    studyType4: "拓展学习",
    studyType5: "面授课程",
    studyType6: "案例分析",
    studyType7: "个人反思",
    studyType8: "调查问卷",
    studyType9: "直播课堂",
    ofPlan: "所属计划",
    ofProject: "所属项目",
    onlyPC: "仅支持PC端",
    isOverdue: "已过期",
    continue: "继续学习",
  },
  // 意见反馈
  feedback: {
    title: "意见反馈",
    navBar1: "培训相关",
    navBar2: "平台疑问",
    navBar3: "课堂内容",
    navBar4: "产品建议",
    contact: "联系我们",
    name: "姓名",
    namePlaceholder: "请输入您的姓名",
    email: "邮箱",
    emailPlaceholder: "请输入您的邮箱",
    tel: "电话",
    telPlaceholder: "请输入您的手机号",
    textPlaceholder: "请输入您的意见或建议",
    submitBtn: "提交",
    submitSuccess: "提交成功",
    call: "我们会尽快给您回复，",
    calls: "您也可拨打：",
  },
  // 查报表
  statement: {
    title: "查报表",
    weeklyStudy: "本周学习时间",
    finishCourse: "已完成资源",
    projectCredit: "已获得项目学分",
    compulsory: "已获得必修学分",
    elective: "已获得选修学分",
    initiateTopic: "已发起话题",
    replyTopic: "已回复话题",
    minutes: "分钟",
    numberOf: "次",
    credits: "分",
    courses: "门",
    aimsTitle: "目标学分",
    startTime: "开始时间:",
    endTime: "结束时间:",
    compulsoryNum: "必修已获得",
    electiveNum: "选修已获得",
    targetNum: "项目已获得",
    creditNum: "已获得学分",
  },
  // 独立考试
  independentTest: {
    description: "试卷描述：",
    totalScore: "试卷总分",
    passScore: "及格分数",
    duration: "试卷时间",
    tested: "已考/总次数",
    noTests: "您没有参与过考试...",
    readOver: "您的试卷待批阅中...",
    theirPapers: "交卷时间：",
    score: "得分",
    gotIt: "答对题数",
    allProblems: "总题数",
    durations: "考试用时",
    pass: "通过",
    noPass: "不通过",
    checkTest: "查看试卷",
    startTest: "开始考试",
    submitBtn: "交卷",
    lastQest: "上一题",
    nextQest: "下一题",
    countDown: "剩余时间",
    timeHint: "考试时间已到",
    qestType1: "单选题",
    qestType2: "多选题",
    qestType3: "判断题",
    qestType4: "问答题",
    qestType5: "填空题",
    qestType6: "拖拽单选",
    qestType7: "拖拽多选",
    qestType8: "段落填空题",
    qestType9: "多行判断题",
    qestType0: "小测试",
    placeholder: "请输入...",
    confirmSubmit: "确认交卷",
    answer: "请输入您的答案...",
    detail: "详情",
    correct: "正确",
    wrong: "错误",
  },
  // 小测验
  examPage: {
    submit: "提交",
    correct: "回答正确",
    wrong: "回答错误",
    closeFeedback: "关闭反馈",
    openFeedback: "查看反馈",
    otherSelect: "看看其他同学怎么选！",
    checkOther: "查看其他学员的回答",
    finish: "完成",
    parsing: "问答解析:",
    reference: "参",
    checkAccuracy: "查看每项题目的正确率",
    answerFeedback: "答案反馈",
    seconds: "秒",
    correctlv: "查看每项题目的正确率:",
    fillIn: "填空题",
    first: "题目1",
    second: "题目2",
    beforeSubmit: "请答完题再提交",
    close: "关闭测评反馈",
    open: "打开测评反馈",
  },
  // 积分
  integral: {
    title: "积分",
    integralRule: "积分规则",
    integralDetail: "积分详情",
    bonus: "累计积分",
    needUpgrade: "距升级还有",
    getIntegral: "如何获得积分",
    added: "额外",
    score: "分",
    allScore: "全局积分",
    projectScore: "项目积分",
  },

  // 公用的一些提示
  public: {
    Tip: "暂无相关数据~",
    HtmlNodata: "亲,没有更多数据了~",
    DataError: "数据异常", // _this.$message.error(_this.$t('public.DataError'));
    RequestError: "请求接口错误", // _this.$message.error(_this.$t('public.RequestError'));
    Previous: "上一章节",
    Next: "下一章节",
    more: "查看更多>",
    RequiredPlan: "必修",
    OptionalPlan: "选修",
    seconds: "秒",
    study: "学习提醒",
    click: "请点击屏幕任意位置",
    konw: "知道了",
    login: "登录",
    index: "首页",
    usercenter: "个人中心",
    feedback: "意见反馈",
    language: "语言设置",
    account: "账号设置",
    emial: "修改邮箱",
    password: "修改密码",
    phone: "修改手机号",
    livelist: "直播列表",
    live: "直播",
    Course_Center: "选修库",
    Training_Plan: "培训计划",
    Quiz: "小测验",
    Online_Course: "在线课程",
    Questionaire: "调查问卷",
    In_Classroom_Information: "面授详情",
    Evaluate_the_instructor: "讲师评估",
    Assignment_BBS: "作业墙",
    Assignment_Details: "作业详情",
    Column: "专栏视频",
    Independent_test: "独立考试",
    Content_Center: "知识汇",
    Students_Comments: "学员评论",
    fav: "收藏",
    Study_Camp: "学习营",
    Program: "学习项目",
    plan: "培训计划",
    case: "案列分析",
    assignment: "作业",
    video: "视频预览",
    file: "文档",
    Illustration: "图文预览",
    Extended_Reading: "拓展学习",
    signing_first: "打卡弹窗",
    siging_second: "行为打卡",
    siging_third: "每日行为打卡",
    siging_forth: "打卡报告",
    try_first: "体验问卷调查",
    try_second: "体验注册",
    try_third: "体验注册信息",
    service: "服务协议",
    message: "消息通",
    forget: "忘记密码",
    dated: "到期啦",
    lessTen1: "评论内容不能少于10个字!",
    lessTen2: "笔记内容不能少于10个字!",
    lessTen3: "讨论内容不能少于10个字!",
    lessTen4: "回复内容不能少于10个字!",
    pullRefresh: "下拉刷新",
    releaseRefresh: "释放更新",
    loadtip: "加载中",
    courseInformation: "课程资料",
    view: "查看",
    allInformation: "全部资料",
  },
  // 学习营
  learningCamp: {
    studycamp: "学习营",
    RequiredPlan: "必修计划",
    OptionalPlan: "选修计划",
    Program: "学习项目",
    All: "全部",
    AllType: "全部分类",
    // 培训计划
    TrainingPlan: "培训计划",
    Learningduration: "学习时间:",
    Downloadcertification: "获取证书",
    Canwatch: "可试看", // 暂无
    minutes: "分钟", // 暂无
    Onlinecourse: "在线课程",
    studiedhours: "已学时长:",
    Credits: "学分",
    fen: "分",
    Study: "学习",
    Exam: "考试",
    Singin: "打卡",
    Drill: "实践工具",
    Exam1: "独立考试",
    Taketheexam: "参加考试",
    Assignment: "作业",
    SubmitAssignment: "提交作业",
    Checkingsoon: "待批阅",
    Questionnaire: "调查问卷",
    FillinQuestionaire: "填写问卷",
    Offlinecourse: "面授课程",
    Courseduration: "面授时间",
    Coursedetails: "课程详情",
    ExpandingReading: "拓展学习",
    HaveRead: "学习",
    StartReading: "学习",
    Live: "直播课堂",
    CaseAnalysis: "案例分析",
    StartAnalying: "开始分析",
    Reflection: "个人反思",
    Thistaskgainsyou: "完成反思报告",
    Writemyrelection: "撰写反思",
    Suggestedcompletiontime: "建议完成时间", // 暂无
    OnlyPC: "仅PC端支持",
    NoStudyProgram: "没有学习项目",
    TestsAvailableAfterStudiesFinished: "学习完成后才能考试",
    ResourcesLocked: "资源未解锁，暂不能学习！",
    ResourcesExpired: "资源已过期!",
    StudyTimeNotReached: "未到学习时间",
    UnlockTheSigning: "课程完成后解锁打卡功能！",
    TodayTaskCompleted: "今日打卡任务已完成",
    SigningInHasExpired: "打卡已过期",
    completed: "完成所有资源后方可解锁证书",
    unlock: "资源未解锁，请先填写申请信息，我们会安排人员和您联系",
    studyPlan: "学习计划",
    noData: "暂无数据~",
    EffectiveTime: "有效时间",
    download: "下载证书",
    certificate: "查看证书",
  },

  // 收藏
  collect: {
    pushCourse: "推送学习",
    community: "学习社区",
    dailyReflection: "每日一省",
    Favorites: "收藏",
    TrainingPlan: "培训计划",
    Program: "学习项目",
    LearningResources: "学习资源",
    Contentcenter: "知识汇",
    Live: "直播",
    SpecialColumn: "专栏",
    Post: "帖子",
    Homepage: "首页",
    MyStudy: "学习营",
    Courses: "选修库",
    Knowledge: "知识汇",
    Due: "到期啦",
    Tip: "暂无相关数据~",
    HtmlNodata: "亲,没有更多数据了~",
    Online: "在线",
    InClassroom: "面授",
    Delete: "删除",
    CollectSuccess: "收藏成功",
    CollectCancle: "取消收藏",
    DataError: "数据异常",
    RequestError: "请求接口错误",

    // 学习项目
    include: "包含",
    ge: "个",
    stages: "阶段",

    // 学习资源
    OnlineCourse: "在线课程",
    Reflection: "个人反思",
    IndependentExam: "独立考试",
    Questionnaire: "调查问卷",
    Assignment: "作业",
    CaseAnalysis: "案例分析",
    ExpandingReading: "拓展学习",
    Facetoface: "面授课程",

    // 知识汇
    Postedat: "发表于",
    Previewunsupported: "手机端不支持",

    // 直播
    days: "天",
    hours: "时",
    minutes: "分",
    Livesessionisover: "直播已结束",
    Instructor: "讲师",
    LiveDuration: "已播时长",
    Starttime: "开播时间",
    Replaytime: "回放时间",
    EndTime: "结束时间",
    OnLive: "直播中",
    Livebroadcast: "未开播",
    Replaying: "回放中",
    Finished: "已结束",
  },
  threeState: {
    Finished: "已完成",
    Incomplete: "未完成",
    Expired: "已过期",
    left: "剩",
    days: "天",
  },
  // 个人中心
  usercenter: {
    Credits: "学分",
    Bonus: "积分",
    History: "学习轨迹",
    Signin: "行为打卡",
    MyReport: "查报表",
    Favorites: "收藏",
    Setting: "设置",
    scoreList: "积分",
  },
  // 设置
  setting: {
    setting: "设置",
    feedback: "意见反馈",
    language: "语言设置",
    exit: "退出登录",
    save: "保存",
    chinese: "简体中文",
    english: "English",
    LogOut: "退出登录成功",
  },
  // 案例分析
  case: {
    Nameofcase: "案例名称",
    CaseDescription: "案例描述",
    NoDescription: "暂无描述~",
    NoComments: "暂无评语~",
    NoAnswer: "暂无回答~",
    AttachmentPreview: "附件预览",
    Previewunsupported: "手机端不支持压缩包文件预览，请至PC端查看",
    Youranswer: "我的回答",
    Inputhere: "请在此输入内容...",
    Submit: "提交",
    Edit: "编辑",
    Checkingsoon: "案例分析待批阅",
    PassScore: "及格分",
    Score: "得分",
    Comments: "评语",
    Uploadunsupported: "手机端不支持上传附件功能，请登录PC端操作",
    UploadAttachment: "上传分析资料",
    fen: "分",
    SubmitSuccess: "提交成功",
    SubmitFail: "提交失败",
    AnswerCannotBeEmpty: "答案不能为空～",
    Exceedingtheupperlimitofthenumberofwords: "超过文字数量上限～",
    IllegalCharacter: "答案中含有非法字符～",
    Browseonthecomputer: "请前往pc端查看",
    // media_preivew
    Video: "视频预览",
    // file_preview
    Documents: "文档预览",
  },
  // 拓展学习
  reading: {
    Documents: "文档详情",
    Video: "视频详情",
    Article: "文章详情",
    Package: "压缩包详情",
  },
  // 作业
  homework: {
    Name: "作业名称",
    Descriptionofassignment: "作业描述",
    NoDescription: "暂无描述~",
    NoComments: "暂无评语~",
    NoAnswer: "暂无回答~",
    AttachmentPreview: "附件预览",
    Previewunsupported: "手机端暂不支持压缩包文件预览，请至PC端查看",
    Youranswer: "我的回答",
    Inputhere: "请在此输入内容...",
    Submit: "提交",
    Edit: "编辑",
    Checkingsoon: "作业待批阅",
    PassScore: "及格分",
    Score: "得分",
    Comments: "评语",
    Uploadunsupported: "手机端暂不支持上传附件功能，请登录PC端操作",
    UploadAttachment: "上传作业资料",
    fen: "分",
    SubmitSuccess: "提交成功",
    SubmitFail: "提交失败",
    AnswerCannotBeEmpty: "答案不能为空～",
    Exceedingtheupperlimitofthenumberofwords: "超过文字数量上限～",
    Limit3000: "最多输入3000字",
    IllegalCharacter: "答案中含有非法字符～",
    Browseonthecomputer: "请前往pc端查看",
  },
  // 打卡
  daka: {
    DailyTracker0: "行为打卡",
    SearchKey: "请输入搜索关键词",
    Ongoing: "进行中",
    End: "已结束",
    All: "全部",
    Project: "所属项目：",
    PeriodofValidity: "打卡有效期：",
    afterinitiated: "开启打卡后开始计算打卡周期",
    Signedintoday: "今日已打卡",
    Signedinthisweek: "本周已打卡",
    Pleasechoose: "请选择打卡类型",
    Thisitemiscompulsory: "此项为必填项",
    Checkallrecords: "查看打卡记录",
    Signin: "打卡",
    Turnonthetracker: "开启打卡",
    records: "打卡记录",
    day: "日",
    wk: "周",
    WeeklyTracker: "每周行为打卡",
    DailyTracker: "每日行为打卡",
    DontShowAgain: "我已理解，不再提醒",
    Successfulsigningin: "打卡成功",
    Makeprogresseveryday: "天天进步！继续加油！",
    SigninReport: "打卡报表",
    StudentName: "学员姓名",
    SigninginPeriod: "打卡时间段",
    RequiredSigninginTime: "需打卡次数",
    CompletedSigninginTime: "已打卡次数",
    TrackerTime: "行为打卡次数",
    No: "第",
    Signingin: "次打卡:",
  },
  // 搜索
  search: {
    hotTags: "热门标签",
    studyResources: "学习资源",
    trainPlan: "培训计划",
    courseCenter: "选修库",
    program: "学习项目",
    contentCenter: "知识汇",
    searchHis: "历史搜索",
    clearHis: "清空历史搜索",
    search: "输入您想搜索的内容...",
    onlineCourse: "在线课程",
    reflection: "个人反思",
    onsiteTraining: "面授课程",
    independentExam: "独立考试",
    queationaire: "调查问卷",
    assignment: "作业",
    caseAnalysis: "案例分析",
    expandingReading: "拓展学习",
    package: "压缩包",
    documents: "文档",
    articles: "文章",
    videos: "视频",
    noData: "没有找到相关资源",
    noMore: "没有更多数据了",
    categoryPlan: "所属计划",
    categoryProject: "所属项目",
    category: "所属分类",
  },
  courseCentre: {
    // 选修库
    tit: "选修库",
    category: "全部分类",
    category_s: "全部",
    sort1: "最新发布",
    sort2: "人气最高",
    sort3: "评价最好",
    h_plan: "隐藏拥有的计划 已选",
    minnum: "最小可选数量",
    maxnum: "最大可选数量",
    s_num: "门",
    option: "可选",
    select: "已选",
    limit: "达到上限",
    limit_p: "限",
    resource: "资源",
    person: "人",
    full: "已满",
    not_start: "未开始",
    close: "已截止",
  },
  courseCentreDetail: {
    // 选修库-计划详情
    tit: "培训计划",
    time: "报名时间",
    stage1: "开始学习",
    stage2: "取消报名",
    stage3: "报名未开始",
    stage4: "人数已满",
    stage5: "报名已截止",
    stage6: "达到选课上限",
    details: "查看详情",
    credits: "学分",
    credits_d: "分",
    duration: "课程时长",
    duration_d: "分钟",
    duration_h: "小时",
    course1: "在线课程",
    course2: "独立考试",
    course3: "作业",
    course4: "调查问卷",
    course5: "面授课程",
    course6: "个人反思",
    course7: "案例分析",
    course8: "拓展学习",
    courseDetail: "课程详情",
    courseInfo: "课程信息",
    courseCredit: "课程学分",
    courseDuration: "课程时长",
    courseDes: "课程介绍",
    courseTarget: "课程目标",
  },
  sub_index: {
    // 下属辅导
    tit_report: "下属报表",
    tit_homework: "下属作业",
    tit_alfx: "下属案例分析",
    tit_reflect: "下属反思",
    tit_do: "下属实践",
    search: "搜索",
    search_plc_r: "姓名",
    search_plc_a: "登录名、姓名、名称",
    study_status1: "未辅导",
    study_status2: "已辅导",
    study_status3: "未提交",
    study_status4: "全部",
    credits: "分",
    credits_d: "分",
    minute: "分钟",
    twice: "次",
    preview: "文档预览",
    do: "实践记录",
    num: "序号",
    name: "实践名",
  },
  sub_report: {
    // 下属报表
    study_dur: "学习时长",
    credit: "获得学分",
    noContent: "暂无内容",
    loading: "正在加载...",
    noMore: "没有更多数据",
    report: "个人反思报表",
    name: "学员姓名",
    time: "提交时间",
    case: "下属案例分析",
  },
  // 实践工具报表
  Practice_tool_report: {
    report: "实践工具报表",
    Item_name: "事项名称",
    Student_Name: "学员姓名",
    Submission_time: "提交时间",
    Case_analysis: "下属案例分析",
  },
  sub_alfx_detail: {
    tit_h: "的作业",
    tit_a: "的案例分析",
    status: "状态",
    credits: "学分",
    submit_time: "提交时间",
    attachment_d: "作业描述",
    attachment_ds: "案例分析描述",
    attachment_p: "附件预览",
    attachment_ps: "附件预览",
    attachment_s: "提交的作业",
    attachment_ss: "提交的案例分析",
    feedback: "反馈",
    pinfen: "评分",
    feedback_p: "评分及反馈",
    submit: "提交",
    pass_score: "本次作业及格分为",
    not_support: "手机端暂不支持查看此文件，请登录PC端查看！",
    score: "评分必须是3位以下数字",
    over: "反馈不能超过500个字",
  },
  // 调查问卷
  survey: {
    Questionnaire: "调查问卷",
    Start: "开始调查",
    SingleChoice: "单选",
    MultipleOptions: "多选",
    QA: "问答",
    Score: "分值",
    Back: "上一页",
    Next: "下一页",
    Submit: "提交",
    Finished: "已完成",
    InputHere: "请输入...",
    over: "调查问卷资源已过期",
    alerts: "有必填项未选择或者未填写",
  },
  // 作业墙
  workingWall: {
    AssignmentBBS: "作业墙",
    Hottest: "最新发布",
    MostCommented: "评论最多",
    MostThumbsUp: "点赞最多",
    Highestpopularity: "人气最高",
    NotSupported: "不支持预览",
    Comments: "评论列表",
    CommentsDetail: "评论详情",
    ReplayComment: "条回复",
    Send: "评论",
    AssignmentDetails: "作业详情",
    Postedat: "发表于:",
    Comment: "评论列表",
    WriteAComment: "写评论",
    MoreComments: "更多评论",
    Content: "请输入您的评论(512字以内)",
    content: "请输入您的评论",
    SubmitComments: "发表评论",
    zip: "zip包仅支持PC端预览",
    length: "暂无内容",
    kong: "评论不能为空",
    over: "评论不能超过512个字",
    add: "添加回复成功",
    noMoreData: "没有更多数据了",
    success: "添加评论成功",
    // AllAssignment:"全部作业"
    AssignmentDes: "作业描述",
    AssignmentSee: "附件预览",
    AssignmentNotSup: "手机端暂不支持压缩包文件预览，请至PC端查看",
    Enclosure: "附件",
    Answer: "回答",
    more: "展开",
    collapse: "收起",
    searchTip: "作业名称/学员姓名/文件名",
  },
  // 专栏视频
  columnVideo: {
    Categories: "全部分类",
    All: "全部",
    Watched: "已观看",
    more: "展开",
    collapse: "收起",
    Audio: "音频",
    seeMore: "查看更多>",
    NoContent: "暂无内容",
    delete: "移除",
    success: "收藏成功",
    del: "取消收藏",
    error: "音频加载失败",
    noMoreData: "没有更多数据了",
  },
  // 面授课程
  faceCourse: {
    onsiteTraining: "面授详情",
    CourseDetails: "课程详情",
    LecturerInformation: "讲师详情",
    EvaluateTheInstructor: "讲师评估",
    CourseEvaluation: "课程评估",
    OnlineExam: "在线考试",
    LearningTime: "时长",
    min: "分钟",
    Assessment: "考核方式",
    TeachingTime: "授课时间",
    TraningLocation: "培训地点",
    completionStatus: "结业状态",
    Score: "结业成绩",
    CourseInformation: "课程概述:",
    LecturerEvaluation: "讲师评估",
    LeaveAComment: "请输入您的评价...",
    Submit: "提交",
    TeacherOver: "教师评估已过期",
    CourseOver: "课程评估已过期",
    OnlineOver: "在线考试已过期",
    NoZero: "评价分数不能为0",
    success: "评价成功",
    sign: "面授签到",
    sign_success: "签到成功",
    click_sign: "点击签到",
    sign_user: "用户名",
    sign_detail: "签到详情",
    undone: "未签到",
    done: "已签到",
    waiting: "待签到",
    unstart: "未开始",
    fen: "分",
  },
  // 学习营详情
  LearningCampleDetail: {
    video: "视频",
    expired: "已过期",
    end: "您的课程体验时间已结束！",
    more: "点击申请体验更多的课程内容！",
    clickMore: "申请更多课程 >",
    contents: "目录",
    comment: "评论",
    Forum: "讨论区",
    Notes: "笔记",
    NoComment: "暂无其他学员评论",
    NoQuestions: "暂无讨论",
    Quiz: "小测验",
    Documents: "文档",
    IllustrationType: "图文",
    Enter: "进入",
    Submit: "发表评论",
    Write: "编辑评论",
    Posting: "发帖",
    writeNotes: "记笔记",
    CompleteAllChapters: "完成所有章节",
    // 至少学习xxx分钟 未翻译
    StudyForAtLeast: "至少学习",
    minutes: "分钟",
    CourseExpired: "课程已过期",
    TimeOfLearning: "已学时长",
    CommentsDetail: "评论详情",
    CommentsLength: "条回复",
    placeHolder: "请输入您的评论",
    Send: "发送",
    WriteAComment: "写评论",
    ChooseScore: "请选择评分",
    InputHere: "请输入您的评论!(521字以内)",
    zero: "请滑动滑块选择评分",
    one: "不满意！课程要改进",
    three: "一般吧！课程还可以",
    seven: "非常好！课程非常棒",
    kong: "评论不能为空",
    over: "评论不能超过521个字",
    success: "评论成功",
    Instructor: "老师参与",
    delete: "删除",
    QA: "详情",
    replayDetail: "回复详情",
    teacher: "(老师)",
    add: "回复成功",
    ReplayPost: "帖子回复",
    Post: "发帖",
    PostContent: "发布内容不能为空",
    overPost: "发布内容不能超过512字",
    addCourse: "发帖成功",
    noMore: "没有更多数据了",
    at: "回复@",
    myNote: "我的笔记",
    classNote: "同学笔记",
    noNote: "暂无笔记",
    secret: "私密",
    placeHolderNotes: "请输入您的笔记！(512字以内)",
    remb: "记录",
    rembSuccess: "添加成功",
    noContent: "暂无内容",
  },
  dragTest: {
    tit_sin: "拖拽单选",
    tit_mul: "拖拽多选",
    tit_sin2: "配对题-单选",
    tit_mul2: "配对题-多选",
    answer_w: "回答错误",
    answer_r: "回答正确",
    answer: "正确答案",
    test_feedback: "反馈",
    turn_on: "查看",
    turn_off: "关闭",
    back: "上一章节",
    next: "下一章节",
    submit: "提交",
  },
  // 消息通
  message: {
    Information: "消息详情",
    Message: "消息通",
    readed: "全部已读",
    unread: "未读",
    read: "已读",
    watch: "立即查看",
    notification: "通知消息",
    myMessage: "我的消息",
    markAllRead: "全部标为已读",
    clearAll: "全部清空",
    allMessage: "全部消息",
    unreads: "未读消息",
  },
  advertisement: {
    adsDetail: "广告详情",
  },
  // 服务协议
  Service: {
    service: "服务协议",
    privacy: "隐私政策",
    registered: "此手机号已注册，请点击进入学习按钮登录平台。",
    domain: "域名:",
    userName: "用户名:",
    password: "密码:",
    information: "以上为您的账号登录信息。",
    study: "进入学习",
    yourinfo: "请提供您的信息:",
    phone: "请输入您的手机号",
    code: "输入验证码",
    codeed: "获取验证码",
    agree: "用户注册即代表同意",
    services: "《服务协议》",
    privacys: "《隐私政策》",
    next: "下一步",
    repeat: "请勿重复点击",
    wrong: "手机号格式不正确",
    reget: "重新获取",
    sended: "验证码已发送",
    phonenull: "手机号不能为空",
    codenull: "验证码不能为空",
    submit: "提交",
    thanks: "感谢您的反馈",
    reply: "我们后续会跟进您的需求！",
    back: "返回继续学习",
    company: "请完善您的公司名称",
    name: "请完善您的名称",
    position: "请完善您的职位",
    email: "请完善您的电子邮箱",
    know: "请勾选了解的途径",
  },
  article: {
    article: "文章",
    show: "展开",
    collapse: "收起",
    suitable: "适用：",
    audio: "音频",
  },
  passwordStrength: {
    weakTips: "8位及以上",
    moderateTips: "8位及以上，至少包含大写字母、小写字母，数字，符号中的两种",
    strengthTips: "8位及以上，至少包含大写字母、小写字母，数字，符号中的三种",
    maxTips: "10位及以上，至少包含大写字母、小写字母，数字，符号中的三种",
    claim: "密码要求",
    nonCompliance: "密码不合规，",
  },
};

export default zh;
